import { useApi } from '@omnipresentgroup/api';
import type {
  CompensationSource,
  GetCompensationConfigResponse,
  GetCompensationConfigResponseAPI,
} from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, CONFIGURATION_API_PATH } from '../constants';
import { transformCompensationConfigFromAPI } from '../mappers';

export const useCompensationConfiguration = ({
  countryCode,
  source,
  enabled,
}: {
  countryCode: string;
  source?: CompensationSource;
  enabled?: boolean;
}) => {
  const { GET } = useApi();

  return useQuery<
    GetCompensationConfigResponseAPI,
    unknown,
    GetCompensationConfigResponse
  >({
    queryKey: [CONFIGURATION_API_PATH, countryCode, source],
    queryFn: () =>
      GET<GetCompensationConfigResponseAPI>(
        `${API_BASE}/${CONFIGURATION_API_PATH}`,
        {},
        {
          country_code: countryCode,
          ...(source ? { source: source } : {}),
        },
      ),
    select: transformCompensationConfigFromAPI,
    enabled: enabled || !!countryCode,
  });
};
